import styled from "styled-components";

export const Container = styled.div`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: flex-start;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  height: 90vh;
  padding: 0 5rem 5rem 5rem;
  width: 68rem;
  
  .num-vol {
    color: #30345C;
    font-size: 1.75rem;
    font-style: normal;
    margin-bottom: 0.7rem;
    margin-top: 4.8rem;
  }
  .name-import {
    color: #30345C;
    font-size: 2.42rem;
    font-style: normal;
    margin-bottom: 1.3rem;
  }
  .restrictions-background {
    align-items: center;
    display: flex;
    height: 2.8rem;
    margin-bottom: 3.5rem;
    width: 13.3rem;
  }
  .name-restrictions {
    color: #FF6F61;
    font-size: 1.2rem;
    font-style: normal;
    
  }
  .service-additional {
    color: #08082B;
    font-size: 1.5rem;
    font-style: normal;
    margin-bottom: 1.5rem;
  }
  .search-name {
    color: #30345C;
    font-size: 1.6rem;
    font-style: normal;
    margin-bottom: 2.56rem;
  }
  .input-search-name {
    background: #FFFFFF;
    border-radius: 0.7rem;
    border-style: hidden;
    box-shadow: 0rem 0.93rem 1.88rem rgba(231, 231, 234, 0.62);
    color: #C6C8CE;
    font-family: Montserrat;
    font-size: 1.5rem;
    height: 5rem;
    padding: 1.62rem;
    width: 52rem;
  }
  .input-search-name:enabled:focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem #0000009e;
    border-color: #000000;
  }
  .border-color {
    background: #002E6C;
    border-radius: 0.7rem;
    border: 0.6rem solid #002E6C;
    color: #FFFFFF;
    height: 5rem;
    text-align: center;
    width: 5rem;
  }
  .border-color:not(a):not(.p-disabled):hover {
    background: #002E6C;
    border-color: #002E6C;
    color: #ffffff;
  }
  .border-color:focus {
    box-shadow: 0 0 0 0.2rem #002E6C;
  }
  .div-button-flex {
    align-items: flex-end;
    display: flex;
    height: 100%;
    
  }
  .th-size-color {
    color: rgba(46, 53, 61, 0.3);
    font-size: 1.32rem;
  }
  .button-style-table {
    align-items: center;
    border-radius: 0.7rem;
    border-style: unset;
    cursor: pointer;
    display: flex;
    height: 2.22rem;
    justify-content: center;
    width: 2.22rem;
  }
  .add-service {
    color: #30345C;
    display: flex;
    font-family: Montserrat;
    font-size: 1.6rem, 
    font-style: normal;
    justify-content: center;
    margin-top: 8rem;
    width: 100%;
  }
  .tableSearch .TableBody tr.trBody {
    background: #ffffff;
    border-radius: 1.1rem;
    box-shadow: 0rem 0.93rem 1.88rem rgba(231, 231, 234, 0.62);
    height: 5rem;
  }
  
  .tableSearch .TableBody tr.trBody td {
    border: hidden;
    color: #08082b;
    font-family: Montserrat;
    font-size: 1.4rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.55rem;
  }
  
  .tableSearch .TableBody tr.trBody .ellipsis-text {
    max-width: 7.08rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .img-loading-spinner-size{
    height: 5rem;
    width: 5rem;
  }
  
  .p-checkbox .p-checkbox-box.p-highlight {
    border-color: #002E6C;
    background: #002E6C;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
    border-color: #002E6C;
    background: #002E6C;
    color: #ffffff;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: #002E6C;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
    box-shadow: 0 0 0 0.02rem #002E6C;
    border-color: #002E6C;
  }
  .p-checkbox .p-checkbox-box.p-highlight:not(.p-disabled):hover {
    border-color: #002E6C;
    background: #002E6C;
    color: #ffffff;
 }
`;

export const ModalService = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  .nnn {
    display: flex;
    justify-content: space-around;
    margin-top: 3rem;
  }
`;
export const ButtonAditionUp = styled.button`
  ${(props) => `
  background-color: ${props.theme.colors.accentGreen};
  
`}
  align-items: center;
  border-radius: 1rem;
  border: none;
  color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  display: flex;
  font-family: Montserrat;
  font-size: 1.56rem;
  height: 6.4rem;
  justify-content: center;
  width: 34.8rem;
  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p58};
    cursor: not-allowed;
  }
`;

export const ContentModal = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  padding: 5rem 3rem;
  scrollbar-width: none;
  width: 63rem;

  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 3rem;
    margin-top: 0;
  }
`;
